import React from "react";
import { Tooltip } from "antd";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import { NotificationsListProps } from "@Components/notifications/NotificationsList";
import { INotificationModel } from "@Models/INotificationPayload";
import { NotificationIcon } from "@Components/notifications/NotificationIcon";
import { Check, Close, Visibility } from "@mui/icons-material";
import IconButton from "@Components/shared/IconButton";

interface NotificationItemProps
    extends Omit<NotificationsListProps, "data" | "onFilterClick" | "isFetching" | "onSetAllViewedClick" | "filter"> {
    notification: INotificationModel;
}

export const NotificationItem: React.FC<NotificationItemProps> = (props: NotificationItemProps) => {
    const { notification } = props;
    switch (notification.payload.actions?.length) {
        case 0:
            return (
                <li>
                    <span className={"notifications-date"}>{moment(notification.dateCreated).fromNow()}</span>
                    <table className="notifications-item">
                        <tbody>
                            <tr>
                                <td>
                                    <NotificationIcon icon={notification.payload.icon} />
                                </td>
                                <td style={{ width: "100%" }}>
                                    <span className="notifications-item-desc">{notification.payload.description}</span>
                                </td>
                                <td style={{ minWidth: "35px" }}>
                                    {notification.status.toLowerCase() === "new" && (
                                        <Tooltip title={"Mark as read"}>
                                            <IconButton
                                                size={"small"}
                                                className="read-icon"
                                                shape="circle"
                                                icon={<Visibility style={{ fontSize: "15px" }} />}
                                                onClick={() => props.onSetViewedClick(notification.notificationId)}
                                            />
                                        </Tooltip>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </li>
            );
        case 1:
            return (
                <li>
                    <span className={"notifications-date"}>{moment(notification.dateCreated).fromNow()}</span>
                    <table className="notifications-item">
                        <tbody>
                            <tr>
                                <td>
                                    <Link
                                        to={`${notification.payload.actions[0].url}`}
                                        onClick={() => props.onSetViewedClick(notification.notificationId)}
                                    >
                                        <NotificationIcon icon={notification.payload.icon} />
                                    </Link>
                                </td>
                                <td style={{ width: "100%" }}>
                                    <Link
                                        to={`${notification.payload.actions[0].url}`}
                                        onClick={() => props.onSetViewedClick(notification.notificationId)}
                                    >
                                        <span className="notifications-item-desc">
                                            {notification.payload.description}
                                        </span>
                                    </Link>
                                </td>
                                <td style={{ minWidth: "35px" }}>
                                    {notification.status.toLowerCase() === "new" && (
                                        <Tooltip title={"Mark as read"}>
                                            <IconButton
                                                size={"small"}
                                                className="read-icon"
                                                shape="circle"
                                                icon={<Visibility style={{ fontSize: "15px" }} />}
                                                onClick={() => props.onSetViewedClick(notification.notificationId)}
                                            />
                                        </Tooltip>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </li>
            );
        case 2:
            const acceptInfo = notification.payload.actions[0];
            const declineInfo = notification.payload.actions[1];
            return (
                <li>
                    <span className={"notifications-date"}>{moment(notification.dateCreated).fromNow()}</span>
                    <table className="notifications-item">
                        <tbody>
                            <tr>
                                <td>
                                    <NotificationIcon icon={notification.payload.icon} />
                                </td>
                                <td style={{ width: "100%" }}>
                                    <span className="notifications-item-desc">{notification.payload.description}</span>
                                </td>
                                <td style={{ minWidth: "35px" }}>
                                    {notification.status.toLowerCase() === "new" && (
                                        <Tooltip title={"Mark as read"}>
                                            <IconButton
                                                size={"small"}
                                                className="read-icon"
                                                shape="circle"
                                                icon={<Visibility style={{ fontSize: "15px" }} />}
                                                onClick={() => props.onSetViewedClick(notification.notificationId)}
                                            />
                                        </Tooltip>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {props.notification.status.toLowerCase() === "new" ? (
                        <div className="notifications-item-actions" style={{ marginBottom: 10 }}>
                            <IconButton
                                onClick={() =>
                                    props.onActionClick(
                                        acceptInfo.method,
                                        acceptInfo.url,
                                        notification.notificationId,
                                        notification.payload.category
                                    )
                                }
                                className="secondary ant-btn-sm flex"
                                icon={<Check style={{ fontSize: "14px" }} />}
                            >
                                Accept
                            </IconButton>
                            <IconButton
                                onClick={() =>
                                    props.onActionClick(
                                        declineInfo.method,
                                        declineInfo.url,
                                        notification.notificationId,
                                        notification.payload.category
                                    )
                                }
                                className="secondary danger ant-btn-sm flex"
                                style={{ marginRight: 0 }}
                                icon={<Close style={{ fontSize: "15px" }} />}
                            >
                                Decline
                            </IconButton>
                        </div>
                    ) : (
                        ""
                    )}
                </li>
            );
    }
    return <></>;
};
